<div class="row">
  <div class="col-12">
    <hr>
  </div>
  <div class="col-12">
    <h3>{{ childName }}
      <!-- <app-button [buttonCssClass]="'group_button_3'" [iconCssClass]="'fa fa-trash'" (click)="deleteClick()" [disabled]="actionInProgress"></app-button> -->
      <span class="infotext" (click)="deleteClick()">
        <a data-toggle="modal" data-target="#modal-del">(löschen)</a>
      </span>
    </h3>
    <p>{{ "Change your child's data" | translate }}</p>
  </div>
</div>
<app-partner-form [partner]='partner' [isChild]="true" (eventFormValid)="onChildFormValid()" (eventFormInvalid)="onChildFormInvalid()"></app-partner-form>
<div class="row">
  <div class="col-12 col-md-6">
    <app-button [title]="'Cancel' | translate" [isLeftStyle]="true" (click)="cancelClick()"></app-button>
  </div>
  <div class="col-12 col-md-6">
    <app-button [title]="'Save' | translate" (clickEvent)="saveClick()" [disabled]="!isSaveButtonEnabled"></app-button>
  </div>
  <div class="col-12">
    <hr>
  </div>
</div>
